import React from "react";
import DashboardPieChart from "../../CommonComponents/Dashboard/DashboardPieChart/DashboardPieChart";

function BettorsBettingBehavior({
  bettorsBettingBehaviorData,
  isApiBettorsBettingBehaviorRunning,
}) {
  const pieData3 = [
    {
      device: "Cash",
      count: bettorsBettingBehaviorData?.only_rcash_player,
      color: "#71BF8A",
    },
    {
      device: "Coin",
      count: bettorsBettingBehaviorData?.only_rcoin_player,
      color: "#F39C12",
    },
    {
      device: "Both",
      count: bettorsBettingBehaviorData?.both_player,
      color: "#F1C40F",
    },
    {
      device: "Never",
      count: bettorsBettingBehaviorData?.not_played,
      color: "#3498DB",
    },
  ];

  return (
    <DashboardPieChart
      title="Bettors betting behavior"
      pieData={pieData3}
      isApiRunning={isApiBettorsBettingBehaviorRunning}
    />
  );
}

export default BettorsBettingBehavior;
